import { useCallback } from "react"

import { FieldErrors } from "react-hook-form"

import { PassHolderFormData } from "../schema"

const FIELD_ORDER: (keyof PassHolderFormData)[] = [
  "passSelection",
  "wtpNumber",
  "firstName",
  "lastName",
  "birthDate",
  "passHolderImage",
  "personCertificate",
  "insurance",
]

const useScrollToFieldError = (formId: string) => {
  const scrollToFirstError = useCallback(
    (errors: FieldErrors<PassHolderFormData>) => {
      const firstErrorField = FIELD_ORDER.find((field) => errors[field])
      if (!firstErrorField) return

      const formElement = document.getElementById(formId)
      if (!formElement) return

      const fieldElement =
        formElement.querySelector<HTMLElement>(`[name="${firstErrorField}"]`) ??
        formElement.querySelector<HTMLElement>(
          `[data-field-name="${firstErrorField}"]`
        )

      if (!fieldElement) return

      if (typeof fieldElement.scrollIntoView === "function") {
        fieldElement.scrollIntoView({ behavior: "smooth", block: "center" })
      }

      const focusTarget =
        fieldElement instanceof HTMLInputElement ||
        fieldElement instanceof HTMLSelectElement ||
        fieldElement instanceof HTMLTextAreaElement
          ? fieldElement
          : fieldElement.querySelector<HTMLElement>(
              "input, button, select, textarea, [tabindex]"
            )

      focusTarget?.focus({ preventScroll: true })
    },
    [formId]
  )

  return { scrollToFirstError }
}

export default useScrollToFieldError
